import { FormBuilderContainer } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { useApiErrorHandlingAsync } from '../../hooks/auth'
import { ActionBar } from '../organisms/form'
import { FormFooter, FormItems } from './components'
import { useDataWithDefaultValues } from './defaultValues'
import { FormBuilderProps } from './types'

export const FormDisabled: FunctionComponent<FormBuilderProps> = ({
  id,
  footerText,
  data,
  config,
  onSubmit,
  onSkip,
  loading,
  options = {},
  tKey,
  t,
  ...props
}) => {
  const form = useForm({
    defaultValues: useDataWithDefaultValues(config, data),
    mode: 'onChange',
  })

  useApiErrorHandlingAsync(form.trigger, [])

  return (
    <FormProvider {...form}>
      <FormBuilderContainer
        data-testid={id}
        onSubmit={form.handleSubmit(onSubmit)}
        width={1}
        {...props}
      >
        <FormItems config={config} options={options} tKey={tKey} t={t} />
        <FormFooter tKey={tKey} tName={footerText} t={t} />
        <ActionBar
          tKey={tKey}
          loading={loading}
          disabled={!form.formState.isValid}
          onDismiss={onSkip}
        />
      </FormBuilderContainer>
    </FormProvider>
  )
}
